import {
  GiBookCover,
  GiBookmarklet,
  GiDualityMask,
  GiQuillInk,
  GiArchiveRegister,
  GiFeather,
} from "react-icons/gi";
import { BsHexagon } from "react-icons/bs";

export const featureList = [
  {
    id: 1,
    icon: <GiBookCover />,
    heading: "Fraszki",
    text: "Fraszki podzielone są na trzy księgi. Kochanowski tworzył fraszki na przestrzeni około dwudziestu lat. Większość z nich powstała w czasie przebywania Kochanowskiego na dworach (1559-1574), pozostałe po przeniesieniu się poety do Czarnolasu. Fraszki w zbiorze nie są ułożone chronologicznie, aczkolwiek w pierwszej i drugiej księdze przeważają fraszki z okresu dworskiego, zaś w trzeciej – czarnoleskiego. Fraszki nie są datowane, jednak zawierają anegdoty, nazwiska bohaterów, adresatów, dzięki czemu można odtworzyć czas powstania niektórych z nich.",
  },
  {
    id: 2,
    icon: <GiBookmarklet />,
    heading: "Pieśni",
    text: "Zbiór pieśni Jana Kochanowskiego, wydany nakładem Drukarni Łazarzowej w 1586 roku (a więc już po śmierci autora). Podzielony był na dwie części – Księgi pierwsze oraz Księgi wtóre. Zawierał 49 utworów i był tym samym największym zbiorem pieśni tego autora. Nie znalazły się w nim jednak wszystkie pieśni poety, części z nich on sam postanowił nie włączać do zbioru, ukazały się one później w książce Fragmenta albo pozostałe pisma (1590).",
  },
  {
    id: 3,
    icon: <GiQuillInk />,
    heading: "Treny",
    text: "Poeta napisał 19 trenów, numerowanych cyframi rzymskimi. Poprzedził je dedykacją: „Orszuli Kochanowskiej, wdzięcznej, uciesznej, niepospolitej dziecinie...”, zaś w drugim wydaniu dołączył utwór Epitafium Hannie Kochanowskiej (poświęcony zmarłej niedługo po Urszuli córce Hannie). Są to utwory o charakterze lamentacyjno-refleksyjnym. Rozpamiętywanie śmierci dwuipółletniej córki prowadzi do rozważań nad nieprzydatnością filozofii stoickiej jako remedium na rozpacz, a także do kryzysu wiary, który poeta próbuje przezwyciężyć w ostatnich utworach zbioru. W ostatnim trenie ukazuje mu się matka, która pociesza go wizją życia pozagrobowego, oraz napomina, by nie trwał w rozpaczy. Treny są najbardziej osobistym dziełem poety, stanowią wypowiedź autobiograficzną.",
  },
  {
    id: 4,
    icon: <GiDualityMask />,
    heading: "Tragedia",
    text: "„Odprawa posłów greckich” jest pierwszym polskim nowożytnym dramatem będącym próbą realizacji założeń odwołujących się do antycznych tradycji tragediopisarskich, zarówno greckich, jak i rzymskich, które autor uzgadniał z renesansową wiedzą na temat gatunku oraz dążeniem do stworzenia jego narodowego ekwiwalentu. Dramat ma budowę niezwykle regularną, choć wyróżnia się miniaturową objętością.",
  },
  {
    id: 5,
    icon: <GiArchiveRegister />,
    heading: "Po łacinie",
    text: "W języku łacińskim stworzył ody (wydane w zbiorze Lyricorum libellus), liczne elegie (Elegiarum libri duo i Elegiarum libri IV – zbiory obejmujące kilkadziesiąt utworów), 123 epigramaty (wydane pod tytułem Foricoenia); jest także autorem panegiryczno-dworskiej sielanki (Dryas Zamchana polonice et latine. Pan Zamchanus latine), łacińskiego epilogu do Odprawy posłów greckich pt. Orpheus Sarmaticus oraz satyry politycznej Gallo crocitanti A’MOIBE’. Do dzisiejszych czasów zachował się jeden autograf napisany przez Kochanowskiego w języku łacińskim, jest to rękopis utworu Dryas Zamchana.... Obecnie znajduje się w zbiorach Biblioteki Narodowej, a jego zdigitalizowaną wersję można obejrzeć w Cyfrowej Bibliotece Narodowej Polona.",
  },
  {
    id: 6,
    icon: <GiFeather />,
    heading: "Psałterz Dawidów",
    text: "Wielkim wkładem Kochanowskiego do polskiej kultury był „Psałterz Dawidów”, nie tyle tłumaczenie, ile swobodna parafraza biblijnej Księgi Psalmów, różnorodna i bogata wersyfikacyjnie. Na utworem poeta pracował wiele lat, przeprowadzając również poważne badania filologiczne nad różnymi przekładami greckimi i łacińskimi.",
  },
];
